import { useIsControlled } from "./useIsControlled.js";

/**
 * Hook that returns a controlled value if it is controlled, otherwise
 * it creates a new value using the provided hook factory.
 */
export const useOptionallyControlledHook = function (hookResult, hookFactory) {
  const isControlled = useIsControlled(hookResult);
  if (isControlled) {
    return hookResult;
  }
  for (var _len = arguments.length, hookFactoryArgs = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    hookFactoryArgs[_key - 2] = arguments[_key];
  }
  return hookFactory(...hookFactoryArgs);
};